module.exports = __webpack_public_path__ + "static/img/PGG.ffa6b657.png";